import React from 'react'
import { Form } from 'react-bootstrap'

const UIFormInputHelperText = ({ text }) => {
  return <Form.Text className="text-muted">{text}</Form.Text>
}

export default UIFormInputHelperText
